module.exports = __webpack_public_path__ + "static/certificate32x-4e90071be0ccfa3bc507aead6b770967.jpg";